@if (currentEnrolledDevices?.length === 0) {
  <web-design-system-notification color="blue" [isDismissible]="false" size="small" class="mt-2">
    <div [innerHTML]="'user-self-service.security.registered-device-hint' | transloco"></div>
    <div class="text-right pt-1">
      <button class="btn btn-link p-0" (click)="deviceRegMode = !deviceRegMode">
        <span>{{ 'onboarding.residence.no-addresses-found-link' | transloco }}</span>
      </button>
    </div>
  </web-design-system-notification>
}

<div class="row mt-2 align-items-center">
  <div class="col-11">
    <h4 class="zero-text p-small-bold">Registrierte Geräte (Secure TAN App)</h4>
  </div>
  <div class="col-1 text-right">
    <button
      class="btn btn-link p-0"
      (click)="deviceRegMode = !deviceRegMode"
      [ngbTooltip]="deviceRegMode ? 'Abbrechen' : 'Hinzufügen'"
      [openDelay]="500"
      placement="bottom"
      [hidden]="deviceRegMode"
    >
      <web-design-system-icon name="add" />
    </button>
  </div>
</div>

<div class="d-flex flex-column">
  @if (!deviceToDelete) {
    @for (device of currentEnrolledDevices; track device.serial) {
      <div class="d-flex align-items-center mb-3">
        <div class="d-flex flex-column flex-grow">
          <div>{{ device.customerDeviceName }}</div>
          <div class="font-size-smaller1">
            {{ device.deviceManufacturer }} / Registriert am
            {{ device.enrolled | date: 'dd.MM.yyyy HH:mm' }}
          </div>
        </div>
        <div>
          <a class="cursor-pointer" (click)="setDeviceToDelete(device)">
            <svg class="icon icon-24 icon-active mb-1 ml-2">
              <use class="icon-trashcan" xlink:href="/assets/img/svgs/svgset.svg#trashcan" />
            </svg>
          </a>
        </div>
      </div>
    }
  }
  @if (deviceToDelete) {
    <div class="mb-3">
      <self-service-apptan-retirement [deviceToRetire]="deviceToDelete" (retirementCanceledOrFinished)="cancelDeviceDeletion()" />
    </div>
  }
  @if (!deviceToDelete && deviceRegMode) {
    <div class="mb-3 mt-2">
      <self-service-apptan-enrollment (enrollmentCanceledOrFinished)="regCanceledOrFinished()" />
    </div>
  }
</div>
